module.exports = __webpack_public_path__ + "static/fonts/alfaslabone-regular.c674e63.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/alfa/alfaslabone-regular.woff2
// module id = 0Nw9
// module chunks = 1